export default __webpack_public_path__ + "static/media/payment-method-mc.0393f768.png";